'use client';

import Script from 'next/script';
import type { ReactNode } from 'react';
import { GDPR } from '@/components/GDPR';
import { useSiteContext } from '@/context/SiteContext';

export const AudienceAcuityBootstrap = (): ReactNode => {
	const { config } = useSiteContext();
	const audienceAcuityConfig = config.analytics?.providers?.AudienceAcuity;

	if (!audienceAcuityConfig?.isEnabled) {
		return null;
	}

	return (
		<GDPR
			purposes={[
				'storage',
				'advertising/basic',
				'personalization',
				'measurement/content',
				'measurement/research',
				'measurement/development',
			]}
			vendorId="audienceacuity"
		>
			<Script
				src="https://d-code.liadm.com/did-008t.min.js"
				strategy="afterInteractive"
			/>
		</GDPR>
	);
};
